/** @format */

import React from "react";
import { Menubar } from "primereact/menubar";
// import { InputText } from "primereact/inputtext";
// import { withAuth } from "@okta/okta-react";
// import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import logo from "../assets/Logo.svg";
import cargillLogo from "../assets/cargillLogo.png";
import userIcon from "../assets/user.svg";
import { pagesList } from "./RouterWithAcess/routes";
import { ReactSVG } from "react-svg";
// import { SURVEY } from "../utils/common"
import CustomLink from "./common/CustomLink";
export default function Navbar(props) {
  const { groups } = props;
  const [showDropdown, Toggle] = React.useState(false);

  function ToggleDropdown() {
    // this.setState({showDropdown : !this.state.showDropdown})
    Toggle(!showDropdown);
  }

  // let items = [
  //   { label: "Home", icon: home, pageLink:"/" , view:"Home"},
  //   { label: "News", icon: news, pageLink: "/news", view: "News" },
  //   { label: "Reports", icon: reports, pageLink: "/reports", view: "Reports" },
  //   { label: "Syndication", icon: syndication, pageLink: "/syndication", view: "Syndication" },
  //   { label: "Poll", icon: poll, pageLink: "/poll", view: "Polls" },
  //   { label: "Users", icon: user_mapping, pageLink: "/users", view: UserList },
  //   { label: "User Mapping", icon: user_mapping, pageLink: "/user-mapping", view: "UserMapping" },
  //   { label: "Channel", icon: channel, pageLink: "/channel", view: "Channel" },
  // ];

  const start = (
    <div>
      <img alt='logo' src={logo} height='40' className='mr-2 image'></img>
      <img alt='logo' src={cargillLogo} height='40' className='mr-2 image' style={{ margin: "0 0 0 1rem" }}></img>
      {/* <span className="heading "> CMS</span> */}
    </div>
  );

  // const end = <i class="pi pi-user picon" style={{'fontSize': '2em'}} onClick={ToggleDropdown}></i>;
  // const end = <div className="picon" onClick={ToggleDropdown}><ReactSVG src={userIcon}/></div>;
  const end = (
    <div className='picon'>
      <img alt='logo' src={userIcon} height='40' className='mr-2 image' onClick={ToggleDropdown}></img>
      {/* <span className="heading "> CMS</span> */}
    </div>
  );

  return (
    <div>
      <div>
        <Menubar start={start} end={end} />
        {showDropdown ? (
          <div className='nameDropdown'>
            <h3>{props.currentUserName}</h3>
            <div onClick={props.logout} className='logoutButton'>
              Logout
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <Sidebar
        visible={true}
        baseZIndex={1000}
        onShow={() => {
          console.log("SIDEBAR::onSHow Cllaed");
        }}
        onHide={() => {
          console.log("SIDEBAR::onHide Called");
        }}
      >
        {pagesList
          .filter((page) => page.roles(Array.isArray(groups) ? groups : []))
          .map((item, index) => {
            const isAuthorized = item.permissions(Array.isArray(groups) ? groups : []);
            const className = !isAuthorized ? "nav nav__disabled" : "nav";
            return (
              <CustomLink
                to={item.pageLink}
                key={index}
                end
                caseSensitive={item.isExact}
                className={className}
                onClick={(event) => {
                  if (!isAuthorized) {
                    event.preventDefault();
                    event.stopPropagation();
                  }
                }}
              >
                <div className='btn1' style={{ backgroundColor: "black !important" }}>
                  <ReactSVG className='icon' src={item.icon} />
                  <span style={{ color: "#cccccc" }}>{item.label}</span>
                </div>
              </CustomLink>
            );
          })}
      </Sidebar>
    </div>
  );
}
